import React from 'react';
import Typography from '@mui/material/Typography';

import './Footer.scss';

const Footer = () => {
  const emailAddress = 'jaingyanvaani@gmail.com';
  const whatsappNumber = '+918767616999';

  return (
    <footer className="footer-container">
      <Typography variant="body1">
        Found any discrepancy?
        <br />
        Email us:{' '}
        <a
          className="link"
          target="_blank"
          rel="noopener noreferrer"
          href={`mailto:${emailAddress}`}
        >
          {emailAddress}
        </a>
        <br />
        WhatsApp:{' '}
        <a
          className="link"
          target="_blank"
          rel="noopener noreferrer"
          href={`https://wa.me/${whatsappNumber}`}
        >
          {whatsappNumber}
        </a>
      </Typography>
      <Typography className="copyright" variant="body2">
        © {new Date().getFullYear()} JainGyanVaani. All rights reserved.
      </Typography>
    </footer>
  );
};

export default Footer;
